import { forwardRef, PropsWithChildren, useState } from "react";
import { TextInput } from "@mantine/core";
import classes from "./index.module.css";
import { FieldError } from "react-hook-form";

export interface ITextInputProps {
  autoFocus?: boolean;
  placeholder?: string;
  id?: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  name?: string;
  type?: string;
  info?: string;
  mask?: string;
  size?: string;
  value: string;
  onChange: () => void;
  onBlur: () => void;
  error?: FieldError;
}

const StyledTextInput = forwardRef<
  HTMLInputElement,
  PropsWithChildren<ITextInputProps>
>(
  (
    {
      label,
      placeholder,
      disabled,
      size = "md", 
        mt='md',
      error,
      value,
      onChange,
      onBlur
    },
    ref
  ) => {
    const [focused, setFocused] = useState(false);
    const floating =
      (value && value?.trim().length !== 0) || focused || undefined;

    const handleBlur = () => {
      onBlur?.();
      setFocused(false);
    };

    return (
      <TextInput
        ref={ref}
        label={label}
        placeholder={placeholder}
        disabled={disabled}
        size={size}
        error={error}
        classNames={classes}
        value={value}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={handleBlur}
        mt={mt}
        autoComplete="nope"
        data-floating={floating}
        labelProps={{ "data-floating": floating }}
      />
    );
  }
);

export default StyledTextInput;
